import styled from "@emotion/styled"

export const StyledLoadingContainer = styled("div")`
  text-align: center;
  vertical-align: middle;
`
